module.exports = {"130903001":"水月寺街道","130903002":"南环中路街道","130903003":"南湖街道","130903004":"市场街道","130903005":"西环中街街道","130903006":"公园街道","130903100":"小王庄镇","130903200":"南陈屯乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130903.json
// module id = 214
// module chunks = 0